// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles-module--wrapper--3X-6k","splashScreen":"styles-module--splashScreen--3Sbj4","title":"styles-module--title--3p0nM","video":"styles-module--video--2tmFt"};